export const unescapeDelimiters = (str?: string | null) => {
	if (!str) return '';
	return str.replace(/\\n/g, '\n').replace(/\\t/g, '\t').replace(/\\r/g, '\r');
};
